<template>
  <Cascader
    v-if="options.length > 0"
    v-model="data"
    placeholder="请选择销售或销售分组"
    clearable
    filterable
    :options="options"
    :props="props"
    @change="handleChange"
  >
    <template slot-scope="{ node, data }">
      <span
        class="sale-info"
        @click="handleClick(node, data)"
      >
        {{ data.label }}
      </span>
    </template>
  </Cascader>
</template>

<script>
import { Cascader } from 'element-ui';

import Request from '@/core/QuRequest';

const req = new Request();

export default {
  components: {
    Cascader,
  },

  model: {
    prop: 'value',
    event: 'change',
  },

  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      data: this.value,
      options: [],
      props: {
        checkStrictly: true,
        expandTrigger: 'hover',
      },
    };
  },

  watch: {
    loading(newVal) {
      this.options = Object.keys(this.options).map((key) => {
        const current = this.options[key];
        current.disabled = this.loading;
        if (current.child) {
          current.children = current.child.map((item) => {
            item.disabled = this.loading;
            return item;
          });
        }
        return current;
      });
    },
  },

  created() {
    this.queryDirectGetSalesList();
  },

  methods: {
    // 获取销售列表
    async queryDirectGetSalesList() {
      const res = await req.send(req.Apis.sales.report.directGetSalesList);
      try {
        if (res.code === 200) {
          this.options = this.formatOptions(res.data);
        }
      } catch (err) {
        this.$message.error(`获取详细数据失败：${err.message || '未知错误'}`);
      }
    },

    // 格式化
    formatOptions(data) {
      return Object.keys(data).map((key) => {
        const current = data[key];
        current.label = current.department_name;
        current.value = current.department_id;
        current.disabled = false;
        if (current.child) {
          current.children = current.child.map((item) => {
            item.label = item.username;
            item.value = item.sales_id;
            item.disabled = false;
            return item;
          });
        }
        return current;
      });
    },

    handleClick(node, data) {
      if (!node.isLeaf) {
        this.data = [data.department_id];
      } else {
        this.data = [data.department_id, data.sales_id];
      }
      this.$emit('change', this.data);
    },

    handleChange(value) {
      this.data = value;
      this.$emit('change', this.data);
    },

    // handleExpandChange(value) {
    //   this.data = value;
    //   this.$emit('change', this.data);
    // },
  },
};
</script>

<style lang="less" scoped>
.sale-info {
  display: inline-block;
  width: 100%;
}
</style>